import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTheme } from "./theme";

export function withPagination(Component, itemsPropName, itemsPerPage = 24) {
    // For some reason, this component needs to be assigned to a variable for
    // the compiling of styled-jsx to not fail. Weird
    const PaginatedComponent = ({ [itemsPropName]: items = [], ...rest }) => {
        const [pagesToShow, setPagesToShow] = useState(1);

        const itemsToShow = items.slice(0, pagesToShow * itemsPerPage);
        const hasMore = itemsToShow.length < items.length;
        const onLoadMore = () => {
            setPagesToShow(pagesToShow + 1);
        };

        const args = {
            [itemsPropName]: itemsToShow,
            ...rest,
        };
        // TODO: keep focus at the top of the newly added items on loading more
        // TODO: Load more probably needs a back to top button too
        return (
            <>
                <Component {...args} />
                <div className="load-more-container">
                    {hasMore && (
                        <ProgressIndicator
                            itemsViewed={itemsToShow}
                            items={items}
                        />
                    )}
                    {hasMore && <LoadMoreButton onClick={onLoadMore} />}
                </div>
                <style jsx>{`
                    .load-more-container {
                        text-align: center;
                        margin-top: 3em;
                    }
                `}</style>
            </>
        );
    };
    return PaginatedComponent;
}

function ProgressIndicator({ itemsViewed, items }) {
    const { contrastTextColor } = useTheme();
    const progress = (itemsViewed.length / items.length) * 100;
    return (
        <div className="progress-indicator">
            <p>
                You've viewed{" "}
                <strong className="progress-indicator__number">
                    {itemsViewed.length}
                </strong>{" "}
                of{" "}
                <strong className="progress-indicator__number">
                    {items.length}
                </strong>{" "}
                items
            </p>
            <span className="progress-indicator__progress-container">
                <span
                    className="progress-indicator__progress"
                    style={{ width: `${progress}%` }}
                />
            </span>
            <style jsx>{`
                .progress-indicator__number {
                    color: ${contrastTextColor};
                }
                .progress-indicator__progress-container {
                    display: block;
                    margin: 1em auto 1.25em;
                    background-color: rgba(0, 0, 0, 0.1);
                    border-radius: 3px;
                    height: 6px;
                    width: 280px;
                }
                .progress-indicator__progress {
                    display: block;
                    background-color: ${contrastTextColor};
                    border-radius: 3px;
                    height: 100%;
                    width: 0;
                }
            `}</style>
        </div>
    );
}

function LoadMoreButton({ onClick }) {
    const { baseFontSize, baseLineHeight, contrastTextColor } = useTheme();
    return (
        <button
            className="load-more-button"
            onClick={onClick}
        >
            Load more
            <style jsx>{`
                .load-more-button {
                    font-size: ${baseFontSize}em;
                    font-weight: 600;
                    line-height: ${baseLineHeight};
                    padding: 0.5em 3em;
                    color: ${contrastTextColor};
                    border-radius: 10px;
                    border: 2px solid ${contrastTextColor};
                    cursor: pointer;
                }
                .load-more-button:hover {
                    background-color: ${contrastTextColor};
                    color: #fff;
                }
                .load-more-button:focus,
                .load-more-button:active {
                    outline: 0;
                    background-color: ${contrastTextColor};
                    color: #fff;
                }
            `}</style>
        </button>
    );
}

LoadMoreButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};
